import React, { useRef } from 'react';
import { CreateJourneyPanelContentProps } from './quickstart';
import { Nullable } from 'src/types/nullable.type';
import { FileUploadForm } from 'src/editor/content-creation/components/file-upload-form';
import * as Yup from 'yup';
import { useMount } from 'react-use';

export const ImportingJourneyStatusParams = {
  steps: [
    {
      label: 'Starting to convert your content',
      duration: 0.15,
    },
    {
      label: 'Writing your new content',
      duration: 0.4,
    },
    {
      label: 'Arranging your content',
      duration: 0.2,
    },
    {
      label: 'Adding some artwork',
      duration: 0.15,
    },
    { label: 'Wrapping up', duration: 0.1 },
  ],
  duration: 1000 * 60 * 3,
};

export const ImportAndConvertValidationSchema = Yup.object({
  aiTopic: Yup.string(),
  file: Yup.mixed(),
});

export const CreateJourneyImportAndConvert = ({ onSubmit, onChange }: CreateJourneyPanelContentProps) => {
  const fileRef = useRef<Nullable<File>>(null);
  const inputElementRef = useRef<Nullable<HTMLTextAreaElement>>(null);

  useMount(() => {
    onChange('aiTopic', '');
  });

  return (
    <>
      <p className='text-neue-journey-large'>
        Convert your document, content, or presentations - Upload as a PDF or copy and paste the contents below.
        This will be rewritten with new artwork generated to work as a Journey.
      </p>
      <div className='flex shrink-0 gap-4'>
        <textarea
          ref={inputElementRef}
          autoFocus
          className='resize-none neue-journey-text-input h-[104px] w-[500px] pb-[50px] light'
          placeholder='Paste content'
          name='aiTopic'
          onChange={(e) => {
            const { value } = e.currentTarget as HTMLTextAreaElement;
            onChange('aiTopic', value);
          }}
          onKeyDown={(e) => {
            if (!e.shiftKey && e.key === 'Enter') {
              e.preventDefault();
              onSubmit({
                file: fileRef.current,
                aiTopic: inputElementRef.current?.value || '',
              });
              return false;
            }
          }}
        />
        <FileUploadForm
          containerClassName='h-[unset] w-40 p-0'
          label='Upload a PDF'
          accept='application/pdf'
          onNewFile={(file: File) => {
            fileRef.current = file;
            onSubmit({
              aiTopic: inputElementRef.current?.value || '',
              file,
            });
          }}
        />
      </div>
    </>
  );
};
